import React from "react";
import DigitzsPayment from "component/dc/payment/digitzs/DigitzsPayment";

const PaymentTerminalPage = () => {
	return (
		<div className="content">
			<DigitzsPayment />
		</div>
	);
};

export default PaymentTerminalPage;
